<template>
    <div class="privacy-page-container hidden-first">
        <div class="info-inner-container">
            <section class="container">
                <div class="row-custom">
                    <div class="team-col privacy-block-first">
                        <h1>Spoedgevallen buiten praktijkuren</h1>
                        <p>
                            Heeft u buiten onze reguliere openingstijden een dringende tandheelkundige spoedsituatie? U kunt terecht bij de <strong>Mondzorg Poli</strong> in 's-Hertogenbosch.
                        </p>
                        <div class="emergency-phone">
                            <strong>Spoed telefoon: <a href="tel:0900-1515" class="contact-link">0900-1515</a></strong>
                        </div>
                    </div>
                    
                    <div class="team-col privacy-block">
                        <h3>Locatie</h3>
                        <div class="location-info">
                            <p>
                                <strong>Mondzorg Poli 's-Hertogenbosch</strong><br>
                                Eekbrouwersweg 4<br>
                                5233 VG 's-Hertogenbosch<br>
                                <strong>Telefoon:</strong> <a href="tel:0900-1515" class="contact-link">0900-1515</a>
                            </p>
                        </div>
                    </div>

                    <div class="team-col privacy-block">
                        <h3>Wanneer contact opnemen?</h3>
                        <p>
                            De spoeddienst is bedoeld voor urgente tandheelkundige problemen die niet kunnen wachten tot de volgende werkdag, zoals:
                        </p>
                        <ul class="when-to-contact-list">
                            <li>Ernstige ontstekingen</li>
                            <li>Nabloedingen</li>
                            <li>Tandletsel door een ongeval</li>
                            <li>Sportongevallen</li>
                            <li>Abcessen</li>
                        </ul>
                    </div>

                    <div class="team-col privacy-block">
                        <h3>Openingstijden spoeddienst</h3>
                        <div class="opening-hours">
                            <p>
                                <strong>Weekenddienst:</strong><br>
                                Vrijdag, zaterdag en zondag – de hele dag
                            </p>
                            <p>
                                <strong>Avonddienst:</strong><br>
                                Maandag t/m donderdag vanaf 17:00 uur
                            </p>
                        </div>
                    </div>

                    <div class="team-col privacy-block">
                        <h3>Belangrijke informatie</h3>
                        <p>
                            Houd rekening met het volgende:
                        </p>
                        <ul class="when-to-contact-list">
                            <li>Vooraf telefonisch aanmelden is <strong>verplicht</strong></li>
                            <li>Neem altijd uw zorgpas en legitimatie mee</li>
                            <li>Bij de Mondzorg Poli is uitsluitend <strong>contante betaling</strong> of <strong>pinbetaling</strong> mogelijk</li>
                        </ul>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
export default {
    name: "Spoed2",
    mounted() {
        const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if(entry.isIntersecting){
            entry.target.classList.add('show-first')
          } 
        })
      })

      const hiddenElements = document.querySelectorAll('.hidden-first')
      hiddenElements.forEach((el) => observer.observe(el))

      document.title = "Spoedgevallen | Tandzorg Gestel | 24/7 Spoed Tandarts Sint-Michielsgestel"
      document.querySelector('meta[name="description"]').setAttribute("content", "Spoedgevallen bij Tandzorg Gestel. Contact informatie voor spoedeisende tandheelkundige hulp in Sint-Michielsgestel en omgeving.");
      this.$store.commit('updateActivePage', 'Spoed')
    }
}

</script>

<style scoped>
.hidden-first {
    opacity: 0;
    transform: translateX(-100px);
    transition: all 1.5s;
}

.show-first {
    opacity: 1;
    transform: translateX(0);
}

.privacy-page-container {
    margin-top: 88px;
}

.row-custom {
    display: flex;
    flex-direction: column;
    row-gap: 20px;
    margin-bottom: 0px;
}

.team-col {
    flex-basis: 100%;
}

.team-col h1 {
    padding-top: 0;
    color: #d63384;
    font-size: 2.5rem;
    margin-bottom: 1.5rem;
    font-weight: 600;
}

.team-col h3 {
    color: #2c3e50;
    margin-top: 2rem;
    margin-bottom: 1rem;
    font-size: 1.8rem;
    font-weight: 600;
    border-bottom: 2px solid #e9ecef;
    padding-bottom: 0.5rem;
}

.team-col p {
    padding: 5px 0 0;
    font-size: 1.4rem;
    line-height: 1.6;
    margin-bottom: 1rem;
    color: #495057;
}

.emergency-phone {
    background: linear-gradient(135deg, #ffd700, #ffed4e);
    border: 1px solid #e6c619;
    border-radius: 12px;
    padding: 1.5rem;
    font-size: 1.6rem !important;
    color: #856404;
    text-align: center;
    margin: 1.5rem 0;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.location-info {
    background-color: #f8f9fa;
    border-left: 4px solid #17a2b8;
    padding: 1.5rem;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.opening-hours {
    background: linear-gradient(135deg, #e8f5e8, #f0f8f0);
    border-radius: 8px;
    padding: 1.5rem;
    border: 1px solid #c3e6cb;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.when-to-contact-list {
    padding: 0;
    padding-left: 0;
    font-size: 1.4rem;
    margin-top: 20px;
    margin-bottom: 13px;
    list-style: none;
}

.when-to-contact-list li {
    padding: 12px 0 12px 20px;
    margin-bottom: 8px;
    background-color: #f8f9fa;
    border-radius: 6px;
    border-left: 4px solid #6c757d;
    position: relative;
    transition: all 0.3s ease;
}

.when-to-contact-list li:hover {
    background-color: #e9ecef;
    border-left-color: #495057;
}

.when-to-contact-list li::before {
    content: "•";
    color: #6c757d;
    font-weight: bold;
    position: absolute;
    left: 8px;
}

.privacy-block {
    margin-bottom: -5px;
}

.privacy-block-first {
    margin-bottom: -5px;
}

@media(max-width: 991px) {
    .privacy-page-container {
        margin-top: 55px;
    }
    
    .row-custom {
        display: flex;
        flex-direction: column;
        row-gap: 0px; 
        margin-bottom: 20px;
    }
    
    h1 {
        font-size: 2rem !important;
    }
    
    .privacy-block {
        margin-top: 20px;
    }
    
    .team-col p {
        padding: 7px 0px 0px;
    }
    
    .emergency-phone {
        font-size: 1.4rem !important;
    }
}
</style>
